/*
 * JK | Header hover menus
 *
 * The theme's desktop nav is built on <details>/<summary>, which only opens on
 * click. CSS can't reveal a collapsed <details>, so the open state is toggled
 * here instead. Touch and small screens are left on the click behaviour.
 */
(function () {
  var DESKTOP = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  var CLOSE_DELAY = 120; // grace period so a diagonal move to the submenu doesn't close it

  var mq = window.matchMedia(DESKTOP);

  function menus() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.header__inline-menu header-menu')
    );
  }

  function open(menu) {
    var details = menu.querySelector('details');
    if (!details || details.hasAttribute('open')) return;
    details.setAttribute('open', '');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function close(menu) {
    // header-menu extends the theme's DetailsDisclosure, which handles aria itself
    if (typeof menu.close === 'function') {
      menu.close();
      return;
    }
    var details = menu.querySelector('details');
    if (!details) return;
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function bind(menu) {
    if (menu.dataset.jkHover === '1') return;
    menu.dataset.jkHover = '1';

    var timer;

    menu.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearTimeout(timer);
      menus().forEach(function (other) {
        if (other !== menu) close(other);
      });
      open(menu);
    });

    menu.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        close(menu);
      }, CLOSE_DELAY);
    });

    // keyboard users keep the click behaviour; don't fight focus
    menu.addEventListener('focusout', function (event) {
      if (!mq.matches) return;
      if (!menu.contains(event.relatedTarget)) close(menu);
    });
  }

  function init() {
    menus().forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // if the device switches to touch, drop anything left open
  if (mq.addEventListener) {
    mq.addEventListener('change', function () {
      if (!mq.matches) menus().forEach(close);
    });
  }
})();
